export default class {
  constructor(manipulated_order_item = {}) {
    let d = this.constructor.defaultValue()
    d['i'] = this.constructor.uuid++
    for (let k of Object.keys(d)) {
      this[k] = d[k]
    }
    for (let k of Object.keys(manipulated_order_item)) {
      let v = manipulated_order_item[k]
      // if(k == "id"){
      //   k = "accepting_order_item_id"
      // }
      if (k == "accepting_date") {
        if (typeof v == "string") {
          v = new Date(v)
        }
      }
      this[k] = v
    }
  }

  static defaultValue() {
    if (this.uuid == undefined) {
      this.uuid = 0
    }
    return {
      _destroy: null
    }
  }
}
